import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/PageShippingForm.css';
import formatDelivery, { DELIVERY_OPTIONS, getDeliveryPrice }from '../utils/formatDelivery';
import ButtonRegular from './ui/ButtonRegular';

function PageShippingForm() {
	const navigate = useNavigate();

	const [form, setForm] = useState({
		firstName: '',
		lastName: '',
		phoneNr: '',
		wantsInvoice: false,
		companyName: '',
		taxId: '',
		regon: '',
		companySameAsClient: false,
		differentShipping: false,

		delivery: {
			method: '',
			label: '',
			price: 0
		},

		clientAddress: {
			street: '',
			building: '',
			apartment: '',
			city: '',
			postalCode: ''
		},

		companyAddress: {
			street: '',
			building: '',
			apartment: '',
			city: '',
			postalCode: ''
		},

		shippingAddress: {
			street: '',
			building: '',
			apartment: '',
			city: '',
			postalCode: ''
		}
	});

	// Kopiowanie adresu klienta do firmy
	useEffect(() => {
		if (form.companySameAsClient) {
			setForm(prev => ({
				...prev,
				companyAddress: { ...prev.clientAddress }
			}));
		}
	}, [form.companySameAsClient, form.clientAddress]);

const handleChange = e => {
	const { name, value, type, checked } = e.target;

	if (name === 'delivery') {
		setForm(prev => ({
			...prev,
			delivery: {
				method: value,
				label: formatDelivery(value),
				price: getDeliveryPrice(value),
			},
		}));
		return;
	}


	if (name.includes('.')) {
		const [section, field] = name.split('.');
		setForm(prev => ({
			...prev,
			[section]: {
				...prev[section],
				[field]: value
			}
		}));
	} else {
		// Obsługa zwykłych pól i checkboxów
		setForm(prev => ({
			...prev,
			[name]: type === 'checkbox' ? checked : value
		}));
	}
};

	const handleSubmit = e => {
		e.preventDefault();

		navigate('/summary', { state: { form } });
	};

	return (
		<form className="delivery-form" onSubmit={handleSubmit}>
			{/* Dane klienta */}
			<h2 className="section-title">Dane klienta</h2>

			<div className="form-group">
				<input
					type="text"
					name="firstName"
					placeholder="Imię"
					value={form.firstName}
					onChange={handleChange}
					required
					className="form-input"
				/>
				<input
					type="text"
					name="lastName"
					placeholder="Nazwisko"
					value={form.lastName}
					onChange={handleChange}
					required
					className="form-input"
				/>
				<input
					type="text"
					name="phoneNr"
					placeholder="Telefon"
					value={form.phoneNr}
					onChange={handleChange}
					required
					className="form-input"
				/>

				<input
					type="text"
					name="clientAddress.street"
					placeholder="Ulica"
					value={form.clientAddress.street}
					onChange={handleChange}
					className="form-input"
				/>
				<input
					type="text"
					name="clientAddress.building"
					placeholder="Nr budynku"
					value={form.clientAddress.building}
					onChange={handleChange}
					required
					className="form-input"
				/>
				<input
					type="text"
					name="clientAddress.apartment"
					placeholder="Nr mieszkania"
					value={form.clientAddress.apartment}
					onChange={handleChange}
					className="form-input"
				/>
				<input
					type="text"
					name="clientAddress.city"
					placeholder="Miasto"
					value={form.clientAddress.city}
					onChange={handleChange}
					required
					className="form-input"
				/>
				<input
					type="text"
					name="clientAddress.postalCode"
					placeholder="Kod pocztowy"
					value={form.clientAddress.postalCode}
					onChange={handleChange}
					required
					className="form-input"
				/>
			</div>

			{/* Faktura */}
			<label className="checkbox-label">
				<input
					type="checkbox"
					name="wantsInvoice"
					checked={form.wantsInvoice}
					onChange={handleChange}
				/>
				Chcę otrzymać fakturę VAT
			</label>

			{form.wantsInvoice && (
				<div className="invoice-fields">
					<input
						type="text"
						name="companyName"
						placeholder="Nazwa firmy"
						value={form.companyName}
						onChange={handleChange}
						required
						className="form-input"
					/>
					<input
						type="text"
						name="taxId"
						placeholder="NIP"
						value={form.taxId}
						onChange={handleChange}
						required
						className="form-input"
					/>
					<input
						type="text"
						name="regon"
						placeholder="REGON"
						value={form.regon}
						onChange={handleChange}
						className="form-input"
					/>

					<label className="checkbox-label">
						<input
							type="checkbox"
							name="companySameAsClient"
							checked={form.companySameAsClient}
							onChange={handleChange}
						/>
						Adres firmy taki jak klienta
					</label>

					<input
						type="text"
						name="companyAddress.street"
						placeholder="Ulica firmy"
						value={form.companyAddress.street}
						onChange={handleChange}
						required
						readOnly={form.companySameAsClient}
						className="form-input"
					/>
					<input
						type="text"
						name="companyAddress.building"
						placeholder="Nr budynku firmy"
						value={form.companyAddress.building}
						onChange={handleChange}
						required
						readOnly={form.companySameAsClient}
						className="form-input"
					/>
					<input
						type="text"
						name="companyAddress.apartment"
						placeholder="Nr mieszkania firmy"
						value={form.companyAddress.apartment}
						onChange={handleChange}
						readOnly={form.companySameAsClient}
						className="form-input"
					/>
					<input
						type="text"
						name="companyAddress.city"
						placeholder="Miasto firmy"
						value={form.companyAddress.city}
						onChange={handleChange}
						required
						readOnly={form.companySameAsClient}
						className="form-input"
					/>
					<input
						type="text"
						name="companyAddress.postalCode"
						placeholder="Kod pocztowy firmy"
						value={form.companyAddress.postalCode}
						onChange={handleChange}
						required
						readOnly={form.companySameAsClient}
						className="form-input"
					/>
				</div>
			)}

			{/* Inny adres dostawy */}
			<label className="checkbox-label">
				<input
					type="checkbox"
					name="differentShipping"
					checked={form.differentShipping}
					onChange={handleChange}
				/>
				Dane dostawy inne niż dane klienta
			</label>

			{form.differentShipping && (
				<div className="shipping-fields">
					<input
						type="text"
						name="shippingAddress.street"
						placeholder="Ulica dostawy"
						value={form.shippingAddress.street}
						onChange={handleChange}
						required
						className="form-input"
					/>
					<input
						type="text"
						name="shippingAddress.building"
						placeholder="Nr budynku dostawy"
						value={form.shippingAddress.building}
						onChange={handleChange}
						required
						className="form-input"
					/>
					<input
						type="text"
						name="shippingAddress.apartment"
						placeholder="Nr mieszkania dostawy"
						value={form.shippingAddress.apartment}
						onChange={handleChange}
						className="form-input"
					/>
					<input
						type="text"
						name="shippingAddress.city"
						placeholder="Miasto dostawy"
						value={form.shippingAddress.city}
						onChange={handleChange}
						required
						className="form-input"
					/>
					<input
						type="text"
						name="shippingAddress.postalCode"
						placeholder="Kod pocztowy dostawy"
						value={form.shippingAddress.postalCode}
						onChange={handleChange}
						required
						className="form-input"
					/>
				</div>
			)}

			{/* Dostawa */}
			<div className="form-group">
				<label>Wybierz opcję dostawy</label>
<select
	name="delivery"
	value={form.delivery.method}
	onChange={handleChange}
	required
	className="form-input"
>
	<option value="">--Wybierz opcję--</option>
	{DELIVERY_OPTIONS.map(option => (
		<option key={option.value} value={option.value}>
			{option.label} – {option.price.toFixed(2)} PLN
		</option>
	))}
</select>
			</div>

			<ButtonRegular type="submit">Przejdź do podsumowania</ButtonRegular>
		</form>
	);
}

export default PageShippingForm;
